import {useQueryClient} from '@github-ui/react-query'
import {pullRequestsLayoutRoute} from '../routes/layout-route'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {useRefetchOnAliveUpdate} from './use-refetch-on-alive-update'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useCallback} from 'react'

export function useGitDataLiveUpdates(channel: string): void {
  const queryClient = useQueryClient()
  const invalidateSharedGitQueries = isFeatureEnabled('new_files_changes_live_update_git_data')

  const {queryKey: tabCountsQueryKey} = useRouteQuery(pullRequestsLayoutRoute, 'tabCounts')
  const {queryKey: diffstatQueryKey} = useRouteQuery(pullRequestsLayoutRoute, 'diffstat')

  const refetch = useCallback(() => {
    if (!invalidateSharedGitQueries) {
      return
    }

    queryClient.invalidateQueries({queryKey: tabCountsQueryKey})
    queryClient.invalidateQueries({queryKey: diffstatQueryKey})
  }, [invalidateSharedGitQueries, queryClient, tabCountsQueryKey, diffstatQueryKey])

  useRefetchOnAliveUpdate(channel, refetch, {git_updated: true})
}
